import { mediaItems } from '@/mocks/home';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20paparazzi%20camera%20flashes%20at%20night%2C%20celebrity%20scandal%20atmosphere%2C%20warm%20crimson%20and%20gold%20tones%2C%20intense%20media%20frenzy%2C%20blurred%20background%20with%20crowd%2C%20mysterious%20mood%2C%20editorial%20photography%2C%20high%20contrast%20lighting&width=800&height=450&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Television%20studio%20with%20dramatic%20red%20spotlight%20and%20empty%20chair%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20of%20reality%20show%2C%20warm%20amber%20lighting%2C%20mysterious%20shadows%2C%20editorial%20photography%20style&width=800&height=450&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20live%20stream%20with%20dramatic%20expressions%2C%20social%20media%20scandal%20mood%2C%20warm%20dark%20tones%2C%20influencer%20controversy%20theme%2C%20intense%20closeup%2C%20editorial%20style%20with%20deep%20shadows&width=800&height=450&seq=media-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Backstage%20of%20talent%20show%20with%20dramatic%20lighting%2C%20contestants%20in%20silhouette%2C%20tense%20competition%20atmosphere%2C%20warm%20crimson%20glow%2C%20mysterious%20mood%2C%20editorial%20photography%20with%20deep%20contrast&width=800&height=450&seq=media-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Brand%20advertisement%20billboard%20being%20taken%20down%20at%20night%2C%20scandal%20aftermath%20scene%2C%20dramatic%20warm%20lighting%2C%20corporate%20crisis%20mood%2C%20urban%20setting%2C%20editorial%20photography%2C%20high%20contrast%20amber%20and%20crimson%20tones&width=800&height=450&seq=media-05&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">媒体视频</h2>
          <span className="text-xs text-foreground-500 mt-1">独家影像资料</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={mediaImages[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-bold text-white ${item.tag === '独家' ? 'bg-primary-500' : item.tag === '热门' ? 'bg-accent-500' : 'bg-secondary-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 rounded text-[11px] text-white font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-xl text-white ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-[11px] text-foreground-500"><i className="ri-eye-line mr-1"></i>{item.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}